module.exports = __webpack_public_path__ + "img/red_x.310f3360.svg";